import Link from 'next/link';
import { BRAND_LEGAL_NAME } from '@/lib/brand';
import { CATEGORY_SLUG_TO_NAME } from '@/lib/category-slugs';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-transparent pt-20 pb-10 relative z-20">
      <div className="container mx-auto px-4">
        {/* Arka plan */}
        <div className="absolute inset-0 bg-white/50 backdrop-blur-sm -z-10"></div>
        
        {/* Top Section with Logo and Newsletter */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-16">
          <div className="max-w-xs">
            <div className="flex items-center space-x-2 mb-5">
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center">
                <span className="text-white font-bold text-lg">F</span>
              </div>
              <span className="text-xl font-bold text-primary-dark">
                {BRAND_LEGAL_NAME}
              </span>
            </div>
    
            <p className="text-gray-700 mb-5">
              1992&apos;den bu yana kaliteli berber ve kuaför salon ekipmanları için <strong className="font-medium text-primary-dark">doğrudan üretici</strong> güvencesi sunmaktayız. İstanbul Topkapı ve İstoç gibi merkezlerden tüm Türkiye&apos;ye imalattan satış yapıyoruz.
            </p>
            <p className="text-sm text-gray-600">
              Firma unvanı: FILIZ DEKORASYON KOZMETIK CAM MOBILYA VE KUAFOR MALZEMELERI SANAYI TICARET LIMITED SIRKETI
            </p>
          </div>

          <div className="w-full md:w-96">
            <h3 className="text-primary-dark font-semibold mb-4">Bültenimize Abone Olun</h3>
            <p className="text-gray-700 mb-4">Yeni ürünler, kampanyalar ve güncellemelerden haberdar olun.</p>
            <form className="flex mb-3">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-grow px-4 py-3 rounded-l-md bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
              <button
                type="submit"
                className="bg-primary hover:bg-primary-dark text-white px-4 py-3 rounded-r-md transition duration-200"
              >
                Abone Ol
              </button>
            </form>
            <div className="flex flex-col gap-2.5 mt-3">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <svg 
                  className="w-5 h-5 text-emerald-600 flex-shrink-0" 
                  fill="currentColor" 
                  fillRule="evenodd" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ChatGPT</title>
                  <path d="M9.205 8.658v-2.26c0-.19.072-.333.238-.428l4.543-2.616c.619-.357 1.356-.523 2.117-.523 2.854 0 4.662 2.212 4.662 4.566 0 .167 0 .357-.024.547l-4.71-2.759a.797.797 0 00-.856 0l-5.97 3.473zm10.609 8.8V12.06c0-.333-.143-.57-.429-.737l-5.97-3.473 1.95-1.118a.433.433 0 01.476 0l4.543 2.617c1.309.76 2.189 2.378 2.189 3.948 0 1.808-1.07 3.473-2.76 4.163zM7.802 12.703l-1.95-1.142c-.167-.095-.239-.238-.239-.428V5.899c0-2.545 1.95-4.472 4.591-4.472 1 0 1.927.333 2.712.928L8.23 5.067c-.285.166-.428.404-.428.737v6.898zM12 15.128l-2.795-1.57v-3.33L12 8.658l2.795 1.57v3.33L12 15.128zm1.796 7.23c-1 0-1.927-.332-2.712-.927l4.686-2.712c.285-.166.428-.404.428-.737v-6.898l1.974 1.142c.167.095.238.238.238.428v5.233c0 2.545-1.974 4.472-4.614 4.472zm-5.637-5.303l-4.544-2.617c-1.308-.761-2.188-2.378-2.188-3.948A4.482 4.482 0 014.21 6.327v5.423c0 .333.143.571.428.738l5.947 3.449-1.95 1.118a.432.432 0 01-.476 0zm-.262 3.9c-2.688 0-4.662-2.021-4.662-4.519 0-.19.024-.38.047-.57l4.686 2.71c.286.167.571.167.856 0l5.97-3.448v2.26c0 .19-.07.333-.237.428l-4.543 2.616c-.619.357-1.356.523-2.117.523zm5.899 2.83a5.947 5.947 0 005.827-4.756C22.287 18.339 24 15.84 24 13.296c0-1.665-.713-3.282-1.998-4.448.119-.5.19-.999.19-1.498 0-3.401-2.759-5.947-5.946-5.947-.642 0-1.26.095-1.88.31A5.962 5.962 0 0010.205 0a5.947 5.947 0 00-5.827 4.757C1.713 5.447 0 7.945 0 10.49c0 1.666.713 3.283 1.998 4.448-.119.5-.19 1-.19 1.499 0 3.401 2.759 5.946 5.946 5.946.642 0 1.26-.095 1.88-.309a5.96 5.96 0 004.162 1.713z" />
                </svg>
                <span>Bazı ürünlerimiz yapay zeka ile desteklenmiştir</span>
              </div>
              <div className="flex items-start gap-2 text-xs text-gray-500">
                <svg 
                  className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <span>Özel ölçü ve isteğe özel üretilen ürünlerimizde iade kabul edilmemektedir.</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 border-t border-gray-200 pt-10">
          {/* Quick Links */}
          <div>
            <h4 className="text-primary-dark font-semibold mb-5">Hızlı Erişim</h4>
            <ul className="space-y-3">
              <FooterLink href="/">Ana Sayfa</FooterLink>
              <FooterLink href="/urunler">Ürünlerimiz</FooterLink>
              <FooterLink href="/hakkimizda">Hakkımızda</FooterLink>
              <FooterLink href="/referanslar">Referanslarımız</FooterLink>
              <FooterLink href="/blog">Blog</FooterLink>
              <FooterLink href="/iletisim">İletişim</FooterLink>
            </ul>
          </div>

          {/* Categories */}
          <div className="md:col-span-2 lg:col-span-2">
            <h4 className="text-primary-dark font-semibold mb-5">Kategorilerimiz</h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3">
              {Object.entries(CATEGORY_SLUG_TO_NAME).map(([slug, name]) => (
                <FooterLink key={slug} href={`/urunler/kategori/${slug}`}>
                  {name}
                </FooterLink>
              ))}
              <FooterLink href="/urunler">
                <span className="font-semibold text-primary">Tüm Ürünler &rarr;</span>
              </FooterLink>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-primary-dark font-semibold mb-5">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="h-5 w-5 text-primary mr-3 mt-0.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-700">Maltepe Mh. Davutpaşa Cd. Tim 2 İş Merkezi No:584 ZEYTİNBURNU İSTANBUL</span>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-primary mr-3 mt-0.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a className="text-gray-700 hover:text-primary transition" href="mailto:filizdekorasyonkozmetik@gmail.com">
                  filizdekorasyonkozmetik@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-primary mr-3 mt-0.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div className="text-gray-700 flex flex-col">
                  <a className="hover:text-primary transition" href="tel:+905323457227">0532 345 72 27</a>
                  <a className="hover:text-primary transition" href="tel:+905365524045">0536 552 40 45</a>
                  <a className="hover:text-primary transition" href="tel:+902122567308">(0212) 256 73 08</a>
                </div>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-primary-dark font-semibold mb-5">Çalışma Saatleri</h4>
            <ul className="space-y-2">
              <li className="flex justify-between text-gray-700">
                <span>Pazartesi - Cuma:</span>
                <span>09:00 - 18:00</span>
              </li>
              <li className="flex justify-between text-gray-700">
                <span>Cumartesi:</span>
                <span>10:00 - 15:00</span>
              </li>
              <li className="flex justify-between text-gray-700">
                <span>Pazar:</span>
                <span>Kapalı</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row md:justify-between items-center">
            <p className="text-gray-700 text-sm mb-4 md:mb-0">
              &copy; {currentYear} {BRAND_LEGAL_NAME}. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center md:justify-end">
              <Link href="/iletisim" className="text-gray-700 hover:text-primary text-sm transition py-2 px-1 inline-flex items-center min-h-[44px]">
                İletişim ve Şirket Bilgileri
              </Link>
              <Link href="/gizlilik-politikasi" className="text-gray-700 hover:text-primary text-sm transition py-2 px-1 inline-flex items-center min-h-[44px]">
                Gizlilik Politikası
              </Link>
              <Link href="/kullanim-kosullari" className="text-gray-700 hover:text-primary text-sm transition py-2 px-1 inline-flex items-center min-h-[44px]">
                Kullanım Koşulları
              </Link>
              <Link href="/cerez-politikasi" className="text-gray-700 hover:text-primary text-sm transition py-2 px-1 inline-flex items-center min-h-[44px]">
                Çerez Politikası
              </Link>
              <Link href="/kullanim-kosullari" className="text-gray-700 hover:text-primary text-sm transition py-2 px-1 inline-flex items-center min-h-[44px]">
                Garanti / Teslimat / İade Koşulları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  return (
    <li>
      <Link href={href} className="text-gray-700 hover:text-primary transition py-1 inline-block min-h-[44px] min-w-0 leading-snug">
        {children}
      </Link>
    </li>
  );
};

export default Footer; 